<template>
  <div
    class="mb-2 flex items-center gap-2 rounded-lg bg-purple-200 px-3 py-2"
    data-testid="pinning-disclaimer"
  >
    <InfoCircleIcon
      class="shrink-0 text-gray-900"
      :class="{ 'size-5': compact, 'size-6': !compact }"
    />
    <span class="m-0 flex-1 text-sm leading-relaxed text-gray-900">
      AI edits your design. If it can't, a free professional artist will.
    </span>
    <button
      type="button"
      class="shrink-0 cursor-pointer rounded border-none bg-transparent text-gray-700 hover:text-gray-900"
      aria-label="Dismiss disclaimer"
      data-testid="pinning-disclaimer-dismiss"
      @click="$emit('dismiss')"
    >
      <CloseIcon
        class="text-gray-700 hover:text-gray-900"
        :class="{ 'size-5': compact, 'size-6': !compact }"
      />
    </button>
  </div>
</template>

<script setup>
import InfoCircleIcon from "assets/icons/info-circle.svg?vue";
import CloseIcon from "assets/icons/menu-close.svg?vue";

defineOptions({ name: "PinningDisclaimer" });

defineProps({
  compact: { type: Boolean, default: false }
});

defineEmits(["dismiss"]);
</script>
